import { useState } from "react";
import Block from './block1';

const EditableBlockList = ({ onHistoryChange }) => {
  const [isOpen, setIsOpen] = useState(false); // Gestion du dropdown
  const [isExpanded, setIsExpanded] = useState(false);
  const [blocks, setBlocks] = useState([]);   // Questions dynamiques
  const [questions, setQuestions] = useState([
    { label: "Allergies", id: 1, response: null }, // Réponse à envoyer
    { label: "Diabetes", id: 2, response: null },
    { label: "Drepanocitose", id: 3, response: null },
  ]);

  // Fonction pour gérer les changements dans les réponses des questions
  const handleQuestionChange = (id, value) => {
    const updatedQuestions = questions.map((question) =>
      question.id === id ? { ...question, response: value } : question
    );
    setQuestions(updatedQuestions);
    onHistoryChange(updatedQuestions, 'allergies');  // Envoie des données vers le parent
  };

  // Fonction pour mettre à jour le label d'une question
  const handleLabelChange = (id, newLabel) => {
    const updatedQuestions = questions.map((question) =>
      question.id === id ? { ...question, label: newLabel } : question
    );
    setQuestions(updatedQuestions);
    onHistoryChange(updatedQuestions, 'allergies');  // Envoie des données vers le parent
  };

  // Gérer l'ouverture/fermeture du dropdown
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleExpand = () => {
    setIsExpanded(true);
  };

  // Ajouter un bloc de question dynamique (Ajout de questions personnalisées)
  const handleAddBlock = () => {
    const newBlock = { label: `New Question ${Date.now()}`, id: Date.now(), response: null };
    setBlocks((prevBlocks) => [...prevBlocks, newBlock]);
    // Send both questions and blocks to parent
    onHistoryChange([...questions, ...blocks, newBlock], 'allergies');
  };

  // Ajouter une fonction pour gérer les changements de label dans les blocs dynamiques
  const handleBlockLabelChange = (blockId, newLabel) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, label: newLabel } : block
    );

    setBlocks(updatedBlocks);

    // Envoyer les données mises à jour au parent
    onHistoryChange([...questions, ...updatedBlocks]);
  };

  const handleBlockContentChange = (blockId, newContent) => {
    const updatedBlocks = blocks.map(block =>
      block.id === blockId ? { ...block, response: newContent } : block
    );
    setBlocks(updatedBlocks);
    // Send both questions and updated blocks to parent
    onHistoryChange([...questions, ...updatedBlocks], 'allergies');
  };

  // Ajouter une nouvelle maladie (Add illness)
  const handleAddQuestionOrMaladie = () => {
    const newEntry = { label: "New Illness", id: Date.now(), response: null };  // Nouveau champ pour ajouter maladie
    setQuestions((prevQuestions) => [...prevQuestions, newEntry]);

    // Mise à jour vers le parent avec la nouvelle question ajoutée
    onHistoryChange([...questions, newEntry], 'allergies');
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold text-center"
          style={{ background: '#FFF6E8', borderRadius: '15px' }}
          onClick={toggleDropdown}
        >
         Historique parental
        </p>
        <i className="bi bi-caret-down-fill pos1" style={{ color: '#FF9800' }}></i>
      </div>

      {isOpen && (
        <div className="row m-4">
          {/* Affichage des maladies et questions dynamiques */}
          {questions.map((question) => (
            <div key={question.id} className="col-6 col-md-3 mb-3">
              <div className="d-flex flex-column">
                {/* Permettre la modification du label */}
                <input
                  type="text"
                  value={question.label}
                  onChange={(e) => handleLabelChange(question.id, e.target.value)}  // Met à jour le label
                  className="form-control"
                  style={{
                    border: 'none',
                    fontWeight: '700',
                    marginBottom: '10px'
                  }}
                />
                <div className="d-flex">
                  <div>
                    <input
                      type="radio"
                      name={question.label}
                      className="form-check-input"
                      id={`consentYes${question.id}`}
                      onChange={() => handleQuestionChange(question.id, 'yes')}
                    />
                    <label htmlFor={`consentYes${question.id}`} className="form-check-label">Yes</label>
                  </div>
                  <div className="ms-4">
                    <input
                      type="radio"
                      name={question.label}
                      className="form-check-input"
                      id={`consentNo${question.id}`}
                      onChange={() => handleQuestionChange(question.id, 'no')}
                    />
                    <label htmlFor={`consentNo${question.id}`} className="form-check-label">No</label>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {/* Ajouter un bloc de question (nouvelle question dynamique) */}
          <div className="col-12">
            <div className="row">
              <div
                className={`mx-auto mb-3 ${isExpanded ? "col-12" : "col-md-6"}`}
                onClick={handleExpand}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-prim"
                    style={{ color: '#0056B3' }}
                    onClick={handleAddQuestionOrMaladie} // Ajouter une nouvelle maladie
                  >
                    <i className="bi bi-plus-circle-fill me-2"></i>
                    <span style={{ textDecoration: 'underline' }}>Add illness</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Ajouter un bloc de question dynamique */}
          <div className="col-12">
            <div className="row">
              <div
                className={`mx-auto mb-3 ${isExpanded ? "col-12" : "col-md-6"}`}
                onClick={handleExpand}
                style={{ cursor: "pointer" }}
              >
                <div>
                  {blocks.map((block) => (
                    <div key={block.id}>
                      <Block
                        initialLabel={block.label}
                        initialContent={block.response || ""}
                        onContentChange={(newContent) => handleBlockContentChange(block.id, newContent)}
                        onLabelChange={(newLabel) => handleBlockLabelChange(block.id, newLabel)}
                      />
                    </div>
                  ))}
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-prim"
                      style={{ color: '#0056B3' }}
                      onClick={handleAddBlock} // Ajouter un nouveau bloc de question
                    >
                      <i className="bi bi-plus-circle-fill me-2"></i>
                      <span style={{ textDecoration: 'underline' }}>Add question</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
